import {ChartLevel} from '../../enums/ChartLevel';

export class ErrorChartState {
    level: ChartLevel;
    month?: number;
    week?: number;

    constructor(level?: ChartLevel, month?: number, week?: number) {
        this.level = level ?? ChartLevel.Month;
        this.month = month;
        this.week = week;
    }
}
